import cacheSmartDocDataAction from '../actions/cacheSmartDocDataAction';
import { ClientItem } from 'owa-mail-store';
import { trace } from 'owa-trace';

const ENTITYID_KEY = '@EntityId';

/**
 * @param item Item associated with smart doc property.
 * @param parsedProperty Parsed property to extract data from.
 */
export default function extractAndCacheSmartDocDataFromProperty(
    item: ClientItem,
    parsedProperty: any
): boolean {
    let validProperty: boolean = false;

    // Extraction ID
    const smartDocExtractionID = parsedProperty[ENTITYID_KEY];

    // Initialize smart doc data if we have extraction ID.
    if (smartDocExtractionID) {
        validProperty = true;
        cacheSmartDocDataAction(item, validProperty, smartDocExtractionID);
    } else {
        trace.info('[extractAndCacheSmartDocDataFromProperty] Cannot parse entity ID. Aborting...');

        const error: Error = new Error('NoEntityIdOnProperty');
        throw error;
    }

    return validProperty;
}
